/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A company member who can be assigned to a claim.
 * @export
 * @interface AssignableUser
 */
export interface AssignableUser {
    /**
     * 
     * @type {number}
     * @memberof AssignableUser
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AssignableUser
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssignableUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AssignableUser
     */
    role: string;
}

/**
 * Check if a given object implements the AssignableUser interface.
 */
export function instanceOfAssignableUser(value: object): value is AssignableUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function AssignableUserFromJSON(json: any): AssignableUser {
    return AssignableUserFromJSONTyped(json, false);
}

export function AssignableUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignableUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'role': json['role'],
    };
}

export function AssignableUserToJSON(json: any): AssignableUser {
    return AssignableUserToJSONTyped(json, false);
}

export function AssignableUserToJSONTyped(value?: AssignableUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'role': value['role'],
    };
}

